import { IonLabel, IonSelect, IonSelectOption } from '@ionic/react';
import { VALID_TACTICS } from './lineupEditorUtils';

interface TacticsSelectorProps {
  tactics: string;
  onChange: (tactics: string) => void;
}

export const TacticsSelector = ({ tactics, onChange }: TacticsSelectorProps) => (
  <>
    <IonLabel className="text-base font-semibold text-gray-800">Táctica</IonLabel>
    <IonSelect
      value={tactics}
      onIonChange={(e) => onChange(e.detail.value)}
      interface="popover"
      className="mt-2"
    >
      {VALID_TACTICS.map((t) => (
        <IonSelectOption key={t} value={t}>
          {t}
        </IonSelectOption>
      ))}
    </IonSelect>
  </>
);
